import React from "react";
import { useTranslation } from "react-i18next";
import { EDepositStatus } from "src/types";
import StatusDeposit from "./StatusDeposit";

const DepositCancel: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  
  return (
    <StatusDeposit
      status={EDepositStatus.Cancel}
      title={t("DEPOSIT_STATUS.DEPOSIT_CANCELED")}
      message={t("DEPOSIT_STATUS.DEPOSIT_CANCELED_NO_CHARGES")}
    />
  );
};

export default DepositCancel;
